import { render } from "./AdicionarListaAluno.vue?vue&type=template&id=2a14b978"
import script from "./AdicionarListaAluno.vue?vue&type=script&lang=js"
export * from "./AdicionarListaAluno.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__